import { CONTACT_EMAIL } from "../config";

type LegalPageProps = {
  type: "privacy" | "terms";
};

export function LegalPage({ type }: LegalPageProps) {
  const isPrivacy = type === "privacy";

  return (
    <main id="main-content" className="legal-page">
      <div className="shell legal-page__inner">
        <div className="legal-page__heading">
          <p className="eyebrow">Website policy</p>
          <h1>{isPrivacy ? "Privacy Policy" : "Website Terms"}</h1>
          <p>Last updated July 25, 2026</p>
        </div>

        {isPrivacy ? (
          <div className="legal-copy">
            <section>
              <h2>About this notice</h2>
              <p>
                This notice describes the current Kratis public website. It is
                not a customer data agreement. Any Decision Review or customer
                workspace will use separate, reviewed terms that define access,
                permitted use, retention, and confidentiality.
              </p>
            </section>
            <section>
              <h2>Information you choose to send</h2>
              <p>
                The website contact form prepares an email in your own email
                application. Kratis may use the information you send to respond
                to your inquiry and discuss a possible engagement. Do not send
                facility records, laboratory files, permits, or other sensitive
                operating information through the public form.
              </p>
            </section>
            <section>
              <h2>Website data</h2>
              <p>
                This version of the site does not include advertising trackers
                or a customer analytics service. A hosting provider may create
                ordinary technical logs needed to deliver and protect the
                website. This notice should be updated if analytics, cookies, or
                another form service is added.
              </p>
            </section>
            <section>
              <h2>Customer information</h2>
              <p>
                Public website inquiries are separate from customer operating
                records. Before Kratis accepts customer records, the parties
                should agree on the scope of work and the rules that govern
                those records.
              </p>
            </section>
            <section>
              <h2>Questions</h2>
              <p>
                Questions about this notice can be sent to{" "}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
              </p>
            </section>
          </div>
        ) : (
          <div className="legal-copy">
            <section>
              <h2>Website purpose</h2>
              <p>
                This website provides general information about Kratis and its
                services. It is not engineering, legal, laboratory,
                environmental, regulatory, accounting, or investment advice.
              </p>
            </section>
            <section>
              <h2>No operating decision</h2>
              <p>
                Website content should not be used as the basis for a facility,
                safety, environmental, compliance, or financial decision.
                Customers and their qualified professionals retain authority
                over their operations and decisions.
              </p>
            </section>
            <section>
              <h2>Service information</h2>
              <p>
                Service descriptions may change as the product develops. No
                result, saving, or outcome is promised by this website.
              </p>
            </section>
            <section>
              <h2>Site materials</h2>
              <p>
                Unless otherwise stated, the Kratis name, visual identity,
                diagrams, and original website text may not be copied or used to
                suggest a relationship with Kratis without permission.
              </p>
            </section>
            <section>
              <h2>Changes</h2>
              <p>
                These terms may be revised as the company, website, and services
                develop. Customer engagements will use separate written
                agreements.
              </p>
            </section>
            <section>
              <h2>Questions</h2>
              <p>
                Questions about these terms can be sent to{" "}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
              </p>
            </section>
          </div>
        )}

        <a className="button button--secondary legal-page__back" href="/">
          Back to Kratis
          <span aria-hidden="true">↖</span>
        </a>
      </div>
    </main>
  );
}
